// Previous/next buttons for the category example gallery in browsers without CSS
// ::scroll-button (see css/site/gallery.css); browsers with it use the native buttons.

export function initGalleries() {
  if (CSS.supports("selector(::scroll-button(*))")) return;

  for (const gallery of document.querySelectorAll(".img-gallery-slider")) {
    const frame = document.createElement("div");
    frame.className = "gallery-frame";
    gallery.before(frame);
    frame.append(gallery);

    const button = (direction, label) => {
      const el = document.createElement("button");
      el.type = "button";
      el.className = `gallery-button gallery-${direction}`;
      el.setAttribute("aria-label", label);
      el.addEventListener("click", () => {
        // Step from the nearest image, so clicks during a smooth scroll still move one image
        const index = Math.round(gallery.scrollLeft / gallery.clientWidth) + (direction === "next" ? 1 : -1);
        gallery.scrollTo({ left: index * gallery.clientWidth });
      });
      frame.append(el);
      return el;
    };
    const prev = button("prev", "Previous image");
    const next = button("next", "Next image");

    const update = () => {
      prev.disabled = gallery.scrollLeft <= 0;
      next.disabled = gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 1;
    };
    gallery.addEventListener("scroll", update, { passive: true });
    update();
    gallery.classList.add("has-buttons");
  }
}
